module.exports = __webpack_public_path__ + "static/media/heatAttencion2.c5bdcf87.png";